
import React from "react";

interface InfiniteScrollProps {
  isLoading: boolean;
  hasMore: boolean;
  loadMore: () => void;
  loadingText?: string;
  endMessage?: string;
}

export const InfiniteScroll: React.FC<InfiniteScrollProps> = ({
  isLoading,
  hasMore,
  loadMore,
  loadingText = "Loading more items...",
  endMessage = "No more items to load"
}) => {
  return (
    <div className="py-4 text-center">
      {isLoading ? (
        <div className="flex flex-col items-center gap-2">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
          <p className="text-sm text-muted-foreground">{loadingText}</p>
        </div>
      ) : hasMore ? (
        <button
          onClick={loadMore}
          className="text-sm text-primary hover:underline focus:outline-none focus:ring-2 focus:ring-primary/20 rounded px-3 py-1"
        >
          Load more
        </button>
      ) : (
        <p className="text-sm text-muted-foreground">{endMessage}</p>
      )}
    </div>
  );
};
